<script setup>
console.log('proste test')
</script>

<template>

</template>

<style scoped lang="scss">

</style>